module.exports = __webpack_public_path__ + "static/kfsu-logo-5f738c9d2a3d50feee51ef10c2bf22ff.svg";